import gql from 'graphql-tag';

export class DocumentsMutations {
  static updateMany = gql`
    mutation UpdateDocuments(
      $documentIds: [String!]!
      $settings: UpdateDocumentSettings = { transferMode: transfer }
      $patch: UpdateDocumentPatch!
    ) {
      updateDocumentsV2(documentIds: $documentIds, settings: $settings, patch: $patch)
    }
  `;

  static update = gql`
    mutation UpdateDocument(
      $documentId: String!
      $settings: UpdateDocumentSettings = { transferMode: transfer }
      $patch: UpdateDocumentPatch!
    ) {
      updateDocumentV2(documentId: $documentId, settings: $settings, patch: $patch)
    }
  `;

  static updateInFolders = gql`
    mutation updateDocumentsInFolder($documentIds: [String!]!, $folderId: String) {
      changeDocumentFolder(documentIds: $documentIds, folderId: $folderId) {
        succeededDocumentIds
        failedDocumentIds
      }
    }
  `;

  static delete = gql`
    mutation DeleteDocuments($ids: [String!]!) {
      deleteDocuments(ids: $ids)
    }
  `;

  static deleteFromFolder = gql`
    mutation DeleteDocumentsFromFolder($folderId: String!, $documentIds: [String!]!) {
      deleteFolderDocuments(folderId: $folderId, documentIds: $documentIds)
    }
  `;

  static sortPages = gql`
    mutation SortDocumentPages(
      $documentId: String!
      $documentPageIds: [String!]!
      $pageNums: [Int!]!
    ) {
      sortDocumentPages(
        payload: { documentId: $documentId, documentPageIds: $documentPageIds, pageNums: $pageNums }
      ) {
        id
        thumbUrl
        pageType
        pageNum
        pageHeight
        pageWidth
        cropBoxH
        cropBoxW
        video {
          id
          thumbUrl
          videoUrl
        }
        contentLinkBlock {
          buttonText
          description
          id
          thumbUrl
          thumbExtension
          title
          url
        }
      }
    }
  `;

  static deletePage = gql`
    mutation DeleteDocumentPage(
      $documentId: String!
      $documentPageId: String!
      $deletedPricingTableIds: [String!]
    ) {
      deleteDocumentPage(
        documentId: $documentId
        documentPageId: $documentPageId
        deletedPricingTableIds: $deletedPricingTableIds
      )
    }
  `;

  static upload = gql`
    mutation UploadContract($payload: [ArchiveDocumentsArgsInput!]!) {
      archiveDocuments(payload: $payload) {
        documentId
        presignedLink {
          url
          headers
        }
        uniqueFilename
      }
    }
  `;

  static getPresignedLinks = gql`
    mutation GetPresignedLinks($payload: [ArchiveDocumentsArgsInput!]!) {
      archiveDocuments(payload: $payload) {
        documentId
        presignedLink {
          url
          headers
        }
        uniqueFilename
      }
    }
  `;

  static uploadFilesDone = gql`
    mutation UploadFilesDoneV2($args: [UploadFilesDoneArgsInput!]!, $jobType: JobType!) {
      uploadFilesDoneV2(args: $args, jobType: $jobType)
    }
  `;

  static updateDocumentTags = gql`
    mutation UpdateDocumentTags($documentIds: [String!]!, $tagIds: [String!]!) {
      addDocumentTags(documentIds: $documentIds, tagIds: $tagIds) {
        tag {
          id
        }
        document {
          id
        }
      }
    }
  `;

  static removeTagsMutation = gql`
    mutation RemoveDocumentTags($documentIds: [String!]!, $tagIds: [String!]!) {
      removeDocumentTags(documentIds: $documentIds, tagIds: $tagIds)
    }
  `;

  static downloadDocuments = gql`
    mutation DownloadDocuments($documentIds: [String!]!) {
      batchDownloadDocuments(documentIds: $documentIds)
    }
  `;

  static downloadDocument = gql`
    mutation DownloadDocument($documentId: String!) {
      download(documentId: $documentId)
    }
  `;

  static createNewVersion = gql`
    mutation CreateNewVersion(
      $documentId: String!
      $keepContent: Boolean!
      $keepRecipients: Boolean!
      $keepEmail: Boolean!
      $recallPrevious: Boolean!
    ) {
      createNewVersion(
        documentId: $documentId
        keepContent: $keepContent
        keepRecipients: $keepRecipients
        keepEmail: $keepEmail
        recallPrevious: $recallPrevious
      ) {
        documentId
      }
    }
  `;

  static recallDocument = gql`
    mutation RecallDocument(
      $documentId: String!
      $sendEmail: Boolean
      $emailSubject: String
      $emailMessage: String
    ) {
      recallDocument(
        documentId: $documentId
        sendEmail: $sendEmail
        emailSubject: $emailSubject
        emailMessage: $emailMessage
      )
    }
  `;

  static updateExpirationDate = gql`
    mutation UpdateDocumentExpiration(
      $documentId: String!
      $expirationDate: Float!
      $sendEmail: Boolean
      $emailSubject: String
      $emailMessage: String
    ) {
      updateDocumentExpiration(
        documentId: $documentId
        expirationDate: $expirationDate
        sendEmail: $sendEmail
        emailSubject: $emailSubject
        emailMessage: $emailMessage
      )
    }
  `;

  static lostDocument = gql`
    mutation LostDocument($documentId: String!) {
      lostDocument(documentId: $documentId)
    }
  `;

  static signedWithoutVerification = gql`
    mutation SignedWithoutVerification($documentId: String!) {
      signedWithoutVerification(documentId: $documentId)
    }
  `;
}
